{
  "register-pin-page": {
    "buttons": {
      "resend": "Gửi lại",
      "submit": "Xác nhận"
    },
    "text": {
      "email-check": "LƯU Ý: Vui lòng kiểm tra cả thư mục thư rác hoặc kiểm tra xem email <strong>{{ email }}</strong> của bạn có đúng không hoặc sử dụng một email khác để đăng ký!",
      "in-second": "sau {{seconds}} giây",
      "not-receive-pin": "Bạn không nhận được bất kỳ mã PIN nào?",
      "pin-incorrect": "Mã PIN không chính xác. Vui lòng kiểm tra nó trong Email của bạn và thử lại.",
      "verify-account": "Xác minh tài khoản của bạn",
      "verify-account-hint": "Mã xác nhận sẽ được gửi đến email của bạn <strong>{{ email }}</strong>"
    }
  }
}
